
import { DepartmentManagerModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import Page from '@/Page.vue';
import { Component, Prop, VModel, Watch } from 'vue-property-decorator';

@Component({})
export default class DepartmentManagerList extends Page {
    @VModel() itemsLocal!: DepartmentManagerModel[];
    @Prop() departmentId!: string;

    get existingManagerIds(): Array<string> {
        return (this.itemsLocal ?? []).select((x) => x.tenantUserId!).toArray();
    }

    @Watch('itemsLocal', { deep: true })
    onItemsChanged() {
        this.$emit('input', this.itemsLocal);
    }

    private addClick() {
        const items = [...(this.itemsLocal ?? [])];
        items.push({
            id: Guid.EmptyGuid(),
            departmentId: this.departmentId,
            tenantUserId: Guid.EmptyGuid(),
        } as DepartmentManagerModel);
        this.itemsLocal = items;
        this.$emit('input', items);
    }

    private deleteItem(index: number) {
        this.itemsLocal.splice(index, 1);
        this.$emit('input', this.itemsLocal);
    }
}
